import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
// --- Import redux
import { connect } from "react-redux";
import { setAuthStatus } from "../../../../store/actionCreators/userDataActionCreator";
import { setCookieExisted } from "../../../../store/actionCreators/appActionCreator";
// Importing hooks
import gaEvents from "../../../../hooks/gaEvents";
import useMakeRequest from "../../../../hooks/useMakeRequest";
import createCookie from "../../../../hooks/createCookie";
import readCookie from "../../../../hooks/readCookie";
// Importing components
import Input from "../../../../components/UI/Input/Input";
import Button from "../../../../components/UI/Button/Button";
// Importing styles and images
import style from "./AccountLogin.module.sass";

function AccountLogin({
  email,
  emailTouch,
  emailHandler,
  emailError,
  password,
  passwordTouch,
  passwordHandler,
  passwordError,
  onBlurHandler,
  setAuthStatusAC,
  userDataError,
  setCookie,
}) {
  const [setParams, data, isLoading, hasError, error] = useMakeRequest();
  const [setParamsCsrf, dataCsrf, isLoadingCsrf] = useMakeRequest();

  const [csrfToken, setCsrfToken] = useState(readCookie("csrf"));

  const paramKey = new URLSearchParams(useLocation().search).get("key");

  useEffect(() => {
    if (!csrfToken) {
      // if token do not exists request it
      setParamsCsrf({
        c: "accountStore",
        a: "getCsrfToken",
      });
    }
  }, [csrfToken]);

  useEffect(() => {
    if (isLoadingCsrf === false && dataCsrf) {
      createCookie("csrf", dataCsrf.csrf, 0); // cookie will expire when user closes browser
      setCsrfToken(dataCsrf.csrf);
    }
  }, [dataCsrf, isLoadingCsrf]);

  useEffect(() => {
    if (data !== "" && data !== null && isLoading === false) {
      createCookie("aAuth", data.aAuth, 30);
      createCookie("_cid", data._cid, 30); // eslint-disable-line
      setCookie(true);
      if (userDataError !== "") setAuthStatusAC(true);
      gaEvents.login();
    }
  }, [data, isLoading]);

  // ---  Login by entry key from query parameters:
  useEffect(() => {
    if (paramKey !== null && paramKey !== undefined) {
      setParams({
        c: "accountStore",
        a: "login",
        p: { key: paramKey, csrf: csrfToken },
      });
    }
  }, [csrfToken]);
  // --- :Login by entry key from query parameters

  const login = (e) => {
    e.preventDefault();
    if (!emailError && !passwordError && csrfToken) {
      setParams({
        c: "accountStore",
        a: "login",
        p: { email, aPassword: password, csrf: csrfToken },
      });
    }
  };

  return (
    <form onSubmit={login} className={style.loginFormBody}>
      {hasError && <div className={style.errorResponse}>{error}</div>}
      {userDataError !== null && (
        <div className={style.errorResponse}>{userDataError}</div>
      )}
      <Input
        type="email"
        id="email"
        placeholder="E-mail"
        value={email}
        onChange={emailHandler}
        onBlur={onBlurHandler}
        onKeyPress={(e) => e.key === "Enter" && login(e)}
        error={emailTouch && emailError && emailError}
        className={style.emailField}
      />
      <Input
        type="password"
        id="password"
        placeholder="Password"
        value={password}
        onChange={passwordHandler}
        onBlur={onBlurHandler}
        onKeyPress={(e) => e.key === "Enter" && login(e)}
        error={passwordTouch && passwordError && passwordError}
        className={style.passwordField}
      />
      <Button
        onSubmit={login}
        className={`btn-primary ${style.btnLogin}`}
        disabled={isLoading || !csrfToken}
      >
        Login
      </Button>
    </form>
  );
}

AccountLogin.defaultProps = {
  email: "",
  emailTouch: false,
  emailError: "",
  emailHandler: () => {},
  onBlurHandler: () => {},
  password: "",
  passwordTouch: false,
  passwordError: "",
  passwordHandler: () => {},
  userDataError: null,
};

AccountLogin.propTypes = {
  email: PropTypes.string,
  emailTouch: PropTypes.bool,
  emailError: PropTypes.string,
  emailHandler: PropTypes.func,
  onBlurHandler: PropTypes.func,
  password: PropTypes.string,
  passwordTouch: PropTypes.bool,
  passwordError: PropTypes.string,
  passwordHandler: PropTypes.func,
  setAuthStatusAC: PropTypes.func.isRequired,
  setCookie: PropTypes.func.isRequired,
  userDataError: PropTypes.string,
};

const mapStateToProps = (state) => ({
  userDataError: state.userDataStore.userDataError,
});

const mapDispatchToProps = {
  setAuthStatusAC: setAuthStatus,
  setCookie: setCookieExisted,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountLogin);
